import React, { Component } from "react";
import { Notification, Table, Checkbox, CheckPicker } from "rsuite";
import { injectIntl } from "react-intl";
import ReactDOM from "react-dom"
import styled from "styled-components";

import { DEFAULT_PER_PAGE_DIALER, TWO_STAGE_DEFAULT_PER_PAGE_DIALER } from "const";
import { resolvePerPage } from "utils";
import { MenuShowColumnsIcon } from "components/base/MenuShowColumns";
import Pagination from "components/client/Pagination";
import BaseTable from "components/base/BaseTable";
import m from "definedMessages";
import Speaker from "../Speaker";

const { Column, HeaderCell, Cell } = Table;


class CustomizableTable extends Component {

    getDefaultPerPage = (props) => {
        return props.defaultPerPage || (props.twoStaged ? TWO_STAGE_DEFAULT_PER_PAGE_DIALER : DEFAULT_PER_PAGE_DIALER);
    };

    getPropPerPage = (props) => {
        return props.perPage ?? props.per_page;
    };

    getResolvedPerPage = (props = this.props) => {
        return props.perPageLSKey
            ? this.state?.perPage ?? this.getInitialPerPage(props)
            : (props.perPage ?? this.getDefaultPerPage(props));
    };

    getInitialPerPage = (props) => {
        return resolvePerPage(
            props.perPageLSKey,
            this.getPropPerPage(props),
            this.getDefaultPerPage(props)
        );
    };


    constructor(props) {
        super(props);

        this.selectedList = new Set();

        this.formatMessage = props.intl.formatMessage.bind(props.intl);

        this.state = {
            columnMenuShow: false,
            selectedRows: new Set(),
            selectAll: false,
            perPage: this.getInitialPerPage(props),
        }
    }

    componentDidUpdate = (prevProps) => {
        if (
            this.props.perPageLSKey !== prevProps.perPageLSKey
            || this.getPropPerPage(this.props) !== this.getPropPerPage(prevProps)
        ) {
            const perPage = this.getInitialPerPage(this.props);

            if (perPage !== this.state.perPage) {
                this.setState({ perPage });
            }
        }
    }

    onChangePage = (page) => {
        const perPage = this.getResolvedPerPage();

        if (this.props.getItems) {
            this.props.getItems(page, perPage);
            return;
        }

        if (this.props.onChangePage)
            this.props.onChangePage(page, perPage);
    };

    onChangePerPage = (value) => {
        const nextPerPage = value;

        if (this.props.perPageLSKey) {
            localStorage.setItem(this.props.perPageLSKey, nextPerPage);
            this.setState({ perPage: nextPerPage });
        }

        if (this.props.getItems) {
            this.props.getItems(1, nextPerPage);
            return;
        }

        if (this.props.onChangePerPage)
            this.props.onChangePerPage(nextPerPage);
    };

    onChangeColumnsTable = (columns) => {
        this.props.onChangeColumns(columns)
    };

    onOpenColumnChangeMenu = (changed) => {
        this.setState({ columnMenuShow: changed })
    };

    getColumnsFromIds = (id_list) => {
        return this.props.pickedColumns.filter(elem => id_list.includes(elem.id));
    };

    onToggleItem = (id, isChecked) => {
        const { useSelectedData, data = [], row_key = "id" } = this.props;

        if (isChecked) {
            this.selectedList.add(id);
        } else {
            this.selectedList.delete(id);
        }

        if (useSelectedData) {
            const checkedData = data.filter(item => item[row_key] === id);
            useSelectedData(checkedData, isChecked)
        }

        this.setSelectParent();
        this.forceUpdate();
    };

    onToggleAll = (isChecked) => {
        const { selectAll } = this.state;
        const { data, isPaginated, isSelectedAll, useSelectedData } = this.props;

        if (!isChecked) {
            Notification.close("allocatedNumberChooser");
        }

        if (isSelectedAll && isChecked && !selectAll && isPaginated) {
            const placement = this.props.rtl ? "topStart" : "topEnd";
            Notification.open({
                top: 67,
                duration: 0,
                description: [
                    <div key="description" className="mb-2">
                        {this.formatMessage(m.doYouWantToChooseRecordsOnAllPages)}
                    </div>,
                    <div key="speaker">
                        <Speaker
                            successText={this.formatMessage(m.yes)}
                            cancelText={this.formatMessage(m.onlyOnThisPage)}
                            onSuccess={() => {
                                this.setState({ selectAll: true }, this.setSelectParent);
                                Notification.closeAll();
                            }}
                            onCancel={() => {
                                Notification.closeAll();
                            }}
                        />
                    </div>
                ],
                key: "allocatedNumberChooser",
                placement
            });
        } else if (!isChecked && selectAll) {
            this.setState({ selectAll: false }, this.setSelectParent);
        }

        for (let row of data) {
            isChecked
                ? this.selectedList.add(this.gettingSelectedItem(row))
                : this.selectedList.delete(this.gettingSelectedItem(row))
        }

        if (useSelectedData) {
            useSelectedData(data, isChecked)
        }

        this.setSelectParent();
        this.forceUpdate();
    };

    setSelectParent = () => {
        const { setSelected } = this.props;
        const { selectAll } = this.state;

        if (!setSelected) return;

        setSelected({
            list: Array.from(this.selectedList.values()),
            all: selectAll
        })
    };

    gettingSelectedItem = (row) => {
        const { row_key = "id" } = this.props;
        return row[row_key];
    };

    clear = () => {
        const { isSelect } = this.props;
        const { selectAll } = this.state;
        if (isSelect) {
            this.selectedList.clear();

            if (selectAll) {
                this.setState({ selectAll: false }, this.setSelectParent)
            } else {
                this.setSelectParent()
            }

        }
    };

    render() {
        const {
            data,
            pickedColumns,
            renderedColumns,
            savedTableColumns,
            count,
            perPage,
            per_page,
            page,
            loading,
            onSaveColumnsTable,
            isSelect,
            isChangedColumns,
            isPaginated,
            actionColumn,
            defaultPerPage,
            wordWrap = false,
            calculatedOuterHeight,
            rowHeight = 35,
            headerHeight = 35,
            twoStaged,
            isMobile = false,
            hidePages = false,
            hidePerPage = false,
            hideTotalCount = false,
            rowClassName = "",
            extraRows = 0,
            rtl,
            moreCount,
            ...props
        } = this.props;

        const { columnMenuShow, selectAll } = this.state;

        const getColumnsFromIds = this.getColumnsFromIds;
        const onChangeColumnsTable = this.onChangeColumnsTable;
        const onOpenColumnChangeMenu = this.onOpenColumnChangeMenu;

        const defaultColumns = pickedColumns && pickedColumns.map(({ id: value, label }) => ({ value, label }));
        const selectedColumnIds = Array.isArray(savedTableColumns)
            ? savedTableColumns
            : defaultColumns && defaultColumns.map(({ value }) => value);

        const columns = [...renderedColumns];

        if (actionColumn) {
            const column = actionColumn();
            columns.push(column);
        }

        let everyRowsChecked = false;
        if (data.length && data.every(
            row => this.selectedList.has(this.gettingSelectedItem(row))
        )) {
            everyRowsChecked = true
        }

        const columnChecked = (
            <Column key="table_toggle" width={50}>
                <HeaderCell>
                    <Checkbox
                        onChange={(value, isChecked) => this.onToggleAll(isChecked)}
                        checked={selectAll || everyRowsChecked}
                        className="columnCheckbox"
                    />
                </HeaderCell>
                <Cell>
                    {(row) => <Checkbox
                        disabled={selectAll}
                        checked={row.checked || this.selectedList.has(this.gettingSelectedItem(row)) || selectAll}
                        onChange={(value, isChecked) => this.onToggleItem(this.gettingSelectedItem(row), isChecked)}
                        className="columnCheckbox"
                    />}
                </Cell>
            </Column>
        );

        if (isSelect && data.length) {
            columns.push(columnChecked);
        }

        // add fixing column to fix horizontal scroll
        const columnMobileFix = (
            <Column key="table_scrollfix" width={0} fixed>
                <HeaderCell></HeaderCell>
                <Cell></Cell>
            </Column>
        );
        columns.push(columnMobileFix);

        // reverse columns for RTL. Haven"t found good CSS solution to fix yet
        if (rtl) columns.reverse();


        // Calculate table height
        const calculatedTableHeight = window.innerHeight - (calculatedOuterHeight || 410);
        const defaultTableRowsHeight = (defaultPerPage || (twoStaged ? TWO_STAGE_DEFAULT_PER_PAGE_DIALER + extraRows : DEFAULT_PER_PAGE_DIALER + extraRows)) * (rowHeight || 35) + (headerHeight || 35);
        // const calculatedTableRows = Math.floor(calculatedTableHeight / (rowHeight || 35));

        const resolvedPerPage = this.getResolvedPerPage();

        return (
            <>
                {
                    !!columnMenuShow &&
                    ReactDOM.createPortal(
                        <CheckPickerPortal onClick={() => onOpenColumnChangeMenu(false)} />
                        , document.body)
                }

                {isChangedColumns &&
                    <MenuShowColumnsIcon
                        icon={!columnMenuShow ? "align-justify" : "indent"}
                        onClick={() => onOpenColumnChangeMenu(!columnMenuShow)}
                    />
                }
                <StyledCheckPicker className="checkPicker__container">
                    <CheckPicker
                        data={defaultColumns}
                        value={selectedColumnIds}
                        onChange={id => {
                            const idList = (id || []).filter(item => typeof item === "string");
                            const comparedColumns = getColumnsFromIds(idList);
                            onChangeColumnsTable(comparedColumns, idList);
                            onSaveColumnsTable(idList);
                        }}
                        open={columnMenuShow}
                        searchable={false}
                        sticky={true}
                        className="checkPicker"
                    />
                </StyledCheckPicker>


                <StyledTable
                    virtualized={!isMobile}
                    height={calculatedTableHeight < defaultTableRowsHeight ? defaultTableRowsHeight : calculatedTableHeight}
                    autoHeight={isMobile || (calculatedTableHeight <= defaultTableRowsHeight && data.length === (twoStaged ? TWO_STAGE_DEFAULT_PER_PAGE_DIALER + extraRows : defaultPerPage || DEFAULT_PER_PAGE_DIALER + extraRows))}
                    headerHeight={isMobile ? undefined : headerHeight}
                    data={data}
                    loading={loading}
                    wordWrap={wordWrap || isMobile}
                    rowHeight={isMobile ? undefined : rowHeight}
                    rowClassName={rowClassName}
                    {...props}
                >
                    {columns}
                </StyledTable>
                {
                    isPaginated &&
                    <Pagination
                        total={count}
                        perPage={resolvedPerPage}
                        activePage={page}
                        moreCount={moreCount}
                        hidePages={hidePages}
                        hidePerPage={hidePerPage}
                        hideTotalCount={hideTotalCount}
                        onChangePage={this.onChangePage}
                        onChangePerPage={this.onChangePerPage}
                    />
                }
            </>

        )
    }
};

export default injectIntl(CustomizableTable, { forwardRef: true })


const CheckPickerPortal = styled.div`
    width: 100%;
    height: ${() => document.body.offsetHeight - 56}px;
    top: 56px;
    left: 0;
    position: absolute;
    z-index: 5;
`;

const StyledCheckPicker = styled.div`
    width: 220px;
    position: absolute;
    
    .checkPicker {
        width: 100%;
        visibility: hidden;
    }
`;

export const StyledTable = styled(BaseTable)`
    .rs-table-cell-content {
        // line-height: 26px;
    }
`;
